import { Text, VStack } from '@chakra-ui/react';
import { Trans } from '@lingui/macro';

import useNavigateBookingEngine from '../../../hooks/useNavigateBookingEngine';
import { BOTTOM_ROUNDED_CONTAINER_PROPS, COMMON_PADDING } from '../../../utils/styleUtil';
import ButtonLink from '../../generic/button/ButtonLink';

const SessionVariantNotBookable = ({ isPricePerParticipant }) => {
  const navigate = useNavigateBookingEngine();

  return (
    <VStack bg="brand.background_secondary" p={COMMON_PADDING} {...BOTTOM_ROUNDED_CONTAINER_PROPS}>
      {isPricePerParticipant && (
        <Text fontSize="sm" fontStyle="italic">
          <Trans>This session is already in your cart and no additional places are available.</Trans>
        </Text>
      )}

      {!isPricePerParticipant && (
        <Text fontSize="sm" fontStyle="italic">
          <Trans>This session is already in your cart and no more are available.</Trans>
        </Text>
      )}

      <Text fontSize="sm" fontStyle="italic">
        <Trans>To make changes, edit the cart item.</Trans>
      </Text>

      <ButtonLink onClick={() => navigate(-1)}>
        <Trans>Go back</Trans>
      </ButtonLink>
    </VStack>
  );
};

export default SessionVariantNotBookable;
